<template>
<v-container fluid>
  <v-row dense>
    <v-col cols="12"></v-col>
  </v-row>
  <v-divider hi class="pa-2 black--text" />
  <v-tabs v-model="tabMain" background-color="primary" dark>
    <v-tab v-for="(item, index) in estatus" :key="index" @click="getStatusAlmacen(item.id)">
      {{ item.nombre }} ({{ item.estatus }})
    </v-tab>
  </v-tabs>
    <v-layout justify-center>
        <v-flex md12>
          <v-row dense>
            <v-col cols="12">
              <!-- <DataTable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/> -->
              <DataTableServer v-if="showtable"
                :datatable='tableServer'
                :on-success='successAction'
                :itemsAction='successAction'
                :on-pagination="pagePagination"
                :on-search="getSearchPagePagination"
              />
            </v-col>
          </v-row>
        </v-flex>
    </v-layout>
    <!-- <InsumoAlmacenDialog v-if="get_dialogMain.dialog&& get_dialogMain.type != 'salidasPrint'" :model="insumo" :params="params"/> -->
    <!-- <InsumoSalidaImprimirDialog v-if="get_dialogMain.dialog && get_dialogMain.type == 'salidasPrint'" :model="insumo"/> -->
    <MainFormDialog v-if="get_dialogMain.dialog" :model="objectMain" :params="paramsDialog" :on-success="dataForm"  />

</v-container>
</template>

<script>
import XLSX from 'xlsx'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTableServer from '@/components/tables/DataTableMainServer'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    tabMain: 0,
    estatus: [],
    statusSelected: {},
    showtable: false,
    nameStatus: '',
    tableServer: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Restaurar', icon: 'mdi-arrange-send-to-back', color: 'warning', action: 'restructurarData', code: 'libre', hidden: '' },
          {
            title: 'Reporte',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'ma.export-list',
            options: [
              { title: 'Reporte General', icon: 'mdi-clipboard-text', color: 'success', action: 'ReportGralInsumos' }
            ]
          }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Insumo', value: 'caracteristicas.descripcion', class: 'black--text' },
          { text: 'Marca', value: 'MarcaModelo', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Disponible', value: 'inventarios.checkin', class: 'black--text', align: 'center' },
          { text: 'Estatus', value: 'Status', align: 'center', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text', align: 'right' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    pages: {},
    params_pagintion: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    pagesDefault: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, params: {}, sortBy: [], sortDesc: [] },
    insumo: {},
    params: {},
    objectMain: {},
    paramsDialog: {}
  }),
  components: {
    // DataTable,
    DataTableServer,
    // InsumoAlmacenDialog,
    // InsumoSalidaImprimirDialog,
    MainFormDialog
  },
  mounted () {
    this.getDataUrl('inventarios.almacen-estatus')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableServer })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjectsService', 'POSTObjectsService']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.GETObjectsService({ url: router, params: this.tipo })
      } else {
        this.getUrlServices()
      }
    },
    getDataPaginationUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTObjectsService({ url: router, data: this.params_pagintion })
      } else {
        this.getUrlServices()
      }
    },
    // *==========*==========*==========* Methods Table Pagination *==========*==========*==========* \\
    pagePagination (val) {
      this.tableServer.header.loading = true
      if (val) this.params_pagintion = val
      else this.params_pagintion = this.pagesDefault

      this.params_pagintion.status_id = this.statusSelected
      this.getDataPaginationUrl('inventario.almacen.insumos.list-paginacion')
    },
    getSearchPagePagination (val) {
      this.tableServer.header.loading = true
      if (val) this.params_pagintion = val
      else this.params_pagintion = this.pagesDefault

      this.params_pagintion.status_id = this.statusSelected
      this.getDataPaginationUrl('inventario.almacen.insumos.list-paginacion')
    },
    getStatusAlmacen (id) {
      this.statusSelected = id
      this.params_pagintion.status_id = id
      if (this.pages) this.pagePagination(this.pages)
    },
    // ========== ========== ========== ========== ========== ========== ========== ==========
    // ========== ========== ========== ========== ========== ========== ========== ==========
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      if (this.statusSelected) {
        this.tableServer.header.loading = true
        this.params_pagintion.status_id = this.statusSelected
        this.getDataPaginationUrl('inventario.almacen.insumos.list-paginacion')
      }
    },
    restructurarData (item) {
      this.$swal.fire({
        title: '¿Estás seguro de reestructurar el registro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, Restructurar',
        cancelButtonText: 'No, Cancelar'
      }).then((result) => {
        if (result.value) {
          const url = this.get_urls['inventarios.struct-cant']
          this.urlGetServiceActionTwo({ url: url })
        }
      })
    },
    ReportGralInsumos (item) {
      this.objectMain = {}
      this.paramsDialog.form = this.get_RangeDateTimeForm
      this.paramsDialog.url = this.get_urls['inventarios.almacen.reporte-general']
      this.paramsDialog.message = 'Registro Agregado Correctamente'
      this.paramsDialog.returnObject = true
      this.SHOW_DIALOG_MAIN({ type: 'ReporteGral', with: 850, title: 'Reporte General' })
      // const url = this.get_urls['inventarios.struct-cant']
      // this.urlGetServiceActionTwo({ url: url })
    },
    outInsumoData (item) {
      this.insumo = {}
      this.params = { tableShow: true, form: this.get_InsumosForm }
      this.SHOW_DIALOG_MAIN({ type: 'generalList', with: 650, title: 'Ingresar Insumo' })
    },

    toEntry (item) {
      this.objectMain = item
      this.paramsDialog = {
        urloption: this.get_urls['inventario.almacen.options'],
        url: this.get_urls['inventario.almacen.execute'],
        process: 2,
        message: 'Registro Agregado Correctamente',
        returnObject: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'entry', form: 'process', with: '800', title: 'Entrada de Insumo' })
    },
    toStock (item) {
      this.objectMain = item
      this.paramsDialog = {
        urloption: this.get_urls['inventario.almacen.options'],
        url: this.get_urls['inventario.almacen.execute'],
        process: 2,
        message: 'Registro Agregado Correctamente',
        returnObject: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'toStock', form: 'process', with: '45%', title: 'Entrada a Stock' })
    },
    toPicking (item) {
      this.objectMain = item
      this.paramsDialog = {
        urloption: this.get_urls['inventario.almacen.options'],
        url: this.get_urls['inventario.almacen.execute'],
        process: 2,
        message: 'Registro Agregado Correctamente',
        returnObject: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'toPicking', form: 'process', with: '45%', title: 'Entrada a Picking' })
    },
    toAssign (item) {
      this.objectMain = item
      this.paramsDialog = {
        urloption: this.get_urls['inventario.almacen.options'],
        url: this.get_urls['inventario.almacen.execute'],
        process: 2,
        message: 'Registro Agregado Correctamente',
        returnObject: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'toAssign', form: 'process', with: '45%', title: 'Salida de Insumo' })
    },
    toReturnPicking (item) {
      this.insumo = item
      this.params = {}
      this.SHOW_DIALOG_MAIN({ type: 'process', with: 500, title: 'Regresar a Picking' })
    },
    toPrintInsumo (item) {
      this.insumo = item
      this.SHOW_DIALOG_MAIN({ type: 'salidasPrint', with: 1100, title: 'Salida de Insumo Imprimir' })
    },
    dataForm ({ name, model }) {
      if (name === 'ReporteGral') {
        const data = XLSX.utils.json_to_sheet(model)
        const workbook = XLSX.utils.book_new()
        const filename = 'ReporteDeInsumos'
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      } else {
        this.refreshData({})
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_object', 'get_dialogMain', 'get_InsumosForm', 'get_RangeDateTimeForm'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('inventarios.almacen-estatus')
    },
    get_objects (val) {
      if (val) {
        this.estatus = []
        this.estatus = val
        this.statusSelected = val[0].id
        this.params_pagintion.status_id = val[0].id
        this.showtable = true
      }
    },
    get_object (vals) {
      if (vals) {
        const title = this.tableServer.header.titles.find(a => a.text === 'Disponible')
        if (title) {
          if (this.statusSelected === 6) title.value = 'inventarios.checkin'
          if (this.statusSelected === 7) title.value = 'inventarios.stock'
          if (this.statusSelected === 8) title.value = 'inventarios.picking'
          if (this.statusSelected === 9) title.value = 'inventarios.out'
        }
        this.tableServer.body.data = vals.data
        this.tableServer.header.loading = false
      }
    },
    get_insumos (items) {
      this.table.body.data = items
      this.table.header.loading = false
    },
    get_objectExport (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      const linkSource = `data:application/pdf;base64,${val}`
      const downloadLink = document.createElement('a')
      const fileName = 'formato.pdf'
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
}
</script>

<style>

</style>
